// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Filters$ReactHooksTemplate = require("../dashboard/filters/filters.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var Pagination$ReactHooksTemplate = require("../common/Pagination.res.js");
var ReportSortBar$ReactHooksTemplate = require("../common/ReportSortBar.res.js");
var PaginationUtils$ReactHooksTemplate = require("../common/PaginationUtils.res.js");
var ReportSortParams$ReactHooksTemplate = require("../common/ReportSortParams.res.js");
var MultipleSelectBox$ReactHooksTemplate = require("../common/MultipleSelectBox.res.js");

function emptyState(param) {
  return {
          name: "",
          header: /* [] */0,
          contents: /* [] */0
        };
}

function noMessage(param) {
  return "";
}

function decodeDownloadReport(json) {
  return Json_decode.field("file_name", Json_decode.string, json);
}

function decodeReportDetails(header, json) {
  return List.map((function (name) {
                return Json_decode.optional((function (param) {
                              return Json_decode.field(name, Json_decode.string, param);
                            }), json);
              }), header);
}

function decode(json) {
  var name = Json_decode.field("name", Json_decode.string, json);
  var header = Json_decode.field("header", (function (param) {
          return Json_decode.list(Json_decode.string, param);
        }), json);
  return {
          name: name,
          header: header,
          contents: Json_decode.field("report_data", (function (param) {
                  return Json_decode.list((function (param) {
                                return decodeReportDetails(header, param);
                              }), param);
                }), json)
        };
}

var ReportData = {
  emptyState: emptyState,
  noMessage: noMessage,
  decodeDownloadReport: decodeDownloadReport,
  decodeReportDetails: decodeReportDetails,
  decode: decode
};

var emptyReports = {
  name: "",
  header: /* [] */0,
  contents: /* [] */0
};

var initialState = {
  loading: true,
  reports: emptyReports,
  toggleFilter: false
};

function reducer(state, x) {
  if (typeof x !== "object") {
    if (x === "FetchReportsInProgress") {
      return {
              loading: true,
              reports: state.reports,
              toggleFilter: state.toggleFilter
            };
    } else {
      return {
              loading: state.loading,
              reports: state.reports,
              toggleFilter: !state.toggleFilter
            };
    }
  } else {
    return {
            loading: false,
            reports: x._0,
            toggleFilter: state.toggleFilter
          };
  }
}

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

var emptyPageInfo = {
  total: "1",
  perPage: "1"
};

function CampaignReport(props) {
  var campaignId = props.campaignId;
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return emptyPageInfo;
      });
  var setPageInfo = match$1[1];
  var pageInfo = match$1[0];
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var sortParams = ReportSortParams$ReactHooksTemplate.fromQuery(Js_dict.get(queryParams, "sort_column"), Js_dict.get(queryParams, "sort_order"), "transaction_date", undefined);
  var sortOrderValue = ReportSortParams$ReactHooksTemplate.sortOrderToQuery(sortParams.sortOrder);
  var sortColumnValue = sortParams.sortColumn;
  var sortKey = sortColumnValue + ":" + sortOrderValue;
  var url = "/api/v1/general_report?campaign_id=" + campaignId + "&page=" + String(currentPage) + "&sort_column=" + sortColumnValue + "&sort_order=" + sortOrderValue;
  var handlePageChange = function (pageNumber) {
    var pageNo = String(pageNumber);
    RescriptReactRouter.push("/campaign/" + campaignId + "/campaign_report?page=" + pageNo + "&sort_column=" + sortColumnValue + "&sort_order=" + sortOrderValue);
  };
  var fetchReport = function (param) {
    return Js_promise.then_((function (param) {
                  var headers = param[0];
                  var x = headers.get("Total");
                  var total = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  var x$1 = headers.get("Per-Page");
                  var perPage = x$1 !== null ? (
                      x$1 === null ? undefined : Caml_option.some(x$1)
                    ) : "1";
                  var report = Js_promise.then_((function (json) {
                          return Promise.resolve(Json_decode.field("report", decode, json));
                        }), param[1]);
                  return Promise.resolve([
                              report,
                              [
                                total,
                                perPage
                              ]
                            ]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
  };
  var onApplyFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
    Curry._1(dispatch, "FetchReportsInProgress");
    Js_promise.then_((function (param) {
            var pageInfo = param[1];
            var perPage = pageInfo[1];
            var total = pageInfo[0];
            Curry._1(setPageInfo, (function (param) {
                    return {
                            total: total,
                            perPage: perPage
                          };
                  }));
            Js_promise.then_((function (report) {
                    return Promise.resolve(Curry._1(dispatch, {
                                    TAG: "FetchReportsCompleted",
                                    _0: report
                                  }));
                  }), param[0]);
            return Promise.resolve();
          }), fetchReport());
  };
  var toggleFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
  };
  React.useEffect((function (param) {
          Curry._1(dispatch, "FetchReportsInProgress");
          Js_promise.then_((function (param) {
                  var pageInfo = param[1];
                  var perPage = pageInfo[1];
                  var total = pageInfo[0];
                  Curry._1(setPageInfo, (function (param) {
                          return {
                                  total: total,
                                  perPage: perPage
                                };
                        }));
                  Js_promise.then_((function (report) {
                          return Promise.resolve(Curry._1(dispatch, {
                                          TAG: "FetchReportsCompleted",
                                          _0: report
                                        }));
                        }), param[0]);
                  return Promise.resolve();
                }), fetchReport());
        }), [
        currentPage,
        sortKey
      ]);
  var renderAnswer = function (status, answerOnly, a) {
    switch (status) {
      case "correct" :
          return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("img", {
                                      className: "h-4 w-4",
                                      src: Image$ReactHooksTemplate.greenTick
                                    }),
                                "Correct"
                              ],
                              className: "flex items-center gap-1"
                            }),
                        JsxRuntime.jsx("div", {
                              children: answerOnly
                            })
                      ]
                    });
      case "partiallycorrect" :
          return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("img", {
                                      className: "h-4 w-4",
                                      src: Image$ReactHooksTemplate.greyTick
                                    }),
                                "Partially Correct"
                              ],
                              className: "flex items-center gap-1"
                            }),
                        JsxRuntime.jsx("div", {
                              children: answerOnly
                            })
                      ]
                    });
      case "wrong" :
          return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("img", {
                                      className: "h-4 w-4",
                                      src: Image$ReactHooksTemplate.errorInfoIcon
                                    }),
                                "Wrong"
                              ],
                              className: "flex items-center gap-1"
                            }),
                        JsxRuntime.jsx("div", {
                              children: answerOnly
                            })
                      ]
                    });
      default:
        return a;
    }
  };
  var headerText = function (input) {
    var split = Js_string.split("(", input);
    var outPut = Belt_List.head(Belt_List.fromArray(split));
    if (outPut !== undefined) {
      return outPut;
    } else {
      return "";
    }
  };
  var tooltipText = function (input) {
    var split = Js_string.split("(", input);
    var outPut = Belt_List.tail(Belt_List.fromArray(split));
    var val = outPut !== undefined ? Js_array.joinWith(" (", Belt_List.toArray(outPut)) : "";
    return Js_string.slice(0, val.length - 1 | 0, val);
  };
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.perPage);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                state.toggleFilter ? JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                        onClose: toggleFilter,
                        onApply: onApplyFilter,
                        showDateFilter: false,
                        showFilterPills: false
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                state.loading ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                              text: "Loading..."
                            }),
                        className: "h-screen w-full animated fadeIn"
                      }) : JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("h2", {
                                        children: state.reports.name,
                                        className: "text-xl font-semibold"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("button", {
                                                children: [
                                                  JsxRuntime.jsx("img", {
                                                        className: "h-4",
                                                        src: Image$ReactHooksTemplate.filterButton
                                                      }),
                                                  "Filters"
                                                ],
                                                className: "inline-flex h-40-px shrink-0 items-center gap-2 rounded-lg border border-gray-400 bg-ghostwhite px-4 text-sm shadow-sm",
                                                id: "filters",
                                                onClick: (function (param) {
                                                    Curry._1(dispatch, "ToggleFilter");
                                                  })
                                              }),
                                          JsxRuntime.jsx(ReportSortBar$ReactHooksTemplate.make, {
                                                sortOptions: {
                                                  hd: {
                                                    key: "transaction_date",
                                                    label: "Transaction Date"
                                                  },
                                                  tl: /* [] */0
                                                },
                                                selectedKey: sortColumnValue,
                                                order: sortParams.sortOrder,
                                                onChange: (function (column, order) {
                                                    var newSortOrderValue = ReportSortParams$ReactHooksTemplate.sortOrderToQuery(order);
                                                    RescriptReactRouter.push("/campaign/" + campaignId + "/campaign_report?page=1&sort_column=" + column + "&sort_order=" + newSortOrderValue);
                                                  })
                                              }),
                                          JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
                                                options: {
                                                  hd: "csv",
                                                  tl: {
                                                    hd: "tsv",
                                                    tl: /* [] */0
                                                  }
                                                },
                                                placeholder: "Download",
                                                placeholderClassName: "mr-2",
                                                handleChange: (function (fileFormat) {
                                                    var download_url = "/api/v1/download_campaign_report?campaign_id=" + campaignId + "&file_format=" + fileFormat + "&sort_column=" + sortColumnValue + "&sort_order=" + sortOrderValue;
                                                    Js_promise.then_((function (file_name) {
                                                            return Promise.resolve((console.log(file_name), RescriptReactRouter.push("/downloads")));
                                                          }), Http$ReactHooksTemplate.fetchGetJSONDecode(download_url, decodeDownloadReport));
                                                  }),
                                                selectedOptions: /* [] */0,
                                                className: "w-160-px shrink-0 rounded-lg border border-gray-300 bg-pigmentblue px-3 py-0 text-white shadow-sm outline-none h-40-px",
                                                optionsHoverColor: "hover:bg-spanishgray rounded-lg ",
                                                listBoxCss: "p-1 rounded-lg "
                                              })
                                        ],
                                        className: "flex shrink-0 items-center gap-3"
                                      })
                                ],
                                className: "flex justify-between items-center px-20-px py-16-px"
                              }),
                          JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                                currentPage: currentPage,
                                totalPages: totalPagesCount,
                                totalRecords: totalCount,
                                perPage: perPageCount,
                                handlePageChange: handlePageChange,
                                itemLabel: "records",
                                className: "mx-20-px mb-4"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("table", {
                                            children: [
                                              JsxRuntime.jsx("thead", {
                                                    children: JsxRuntime.jsx("tr", {
                                                          children: $$Array.of_list(List.mapi((function (i, header) {
                                                                      var tooltip = tooltipText($$String.capitalize_ascii(header));
                                                                      return JsxRuntime.jsx("th", {
                                                                                  children: JsxRuntime.jsxs("div", {
                                                                                        children: [
                                                                                          tooltip === "" ? $$String.capitalize_ascii(header) : JsxRuntime.jsxs("div", {
                                                                                                  children: [
                                                                                                    JsxRuntime.jsx("p", {
                                                                                                          children: headerText($$String.capitalize_ascii(header)),
                                                                                                          className: "truncate [max-width:150px]"
                                                                                                        }),
                                                                                                    JsxRuntime.jsx("div", {
                                                                                                          children: tooltipText($$String.capitalize_ascii(header)),
                                                                                                          className: "tooltip-container-text custom-tooltip-response-report"
                                                                                                        })
                                                                                                  ],
                                                                                                  className: "tooltip-container"
                                                                                                }),
                                                                                          JsxRuntime.jsx("img", {
                                                                                                className: "ml-4-px",
                                                                                                src: Image$ReactHooksTemplate.heading
                                                                                              })
                                                                                        ],
                                                                                        className: "flex"
                                                                                      }),
                                                                                  className: "px-4 py-2"
                                                                                }, String(i));
                                                                    }), state.reports.header))
                                                        }),
                                                    className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                                  }),
                                              JsxRuntime.jsx("tbody", {
                                                    children: $$Array.of_list(List.mapi((function (i, x) {
                                                                return JsxRuntime.jsx("tr", {
                                                                            children: $$Array.of_list(List.mapi((function (k, step) {
                                                                                        if (step === undefined) {
                                                                                          return JsxRuntime.jsx("td", {
                                                                                                      children: "",
                                                                                                      className: "px-4 py-2"
                                                                                                    }, String(k));
                                                                                        }
                                                                                        var parts = Js_string.split(" ", step);
                                                                                        var status = Belt_Array.get(parts, 0);
                                                                                        var answerOnly = Js_array.joinWith(" ", Belt_Array.sliceToEnd(parts, 1));
                                                                                        var answerText = status !== undefined ? renderAnswer(status, answerOnly, step) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
                                                                                        return JsxRuntime.jsx("td", {
                                                                                                    children: answerText,
                                                                                                    className: "px-4 py-2"
                                                                                                  }, String(k));
                                                                                      }), x)),
                                                                            className: "border-b border-bottom-gray-600"
                                                                          }, String(i));
                                                              }), state.reports.contents))
                                                  })
                                            ],
                                            className: "text-left table-auto w-full border-separate text-xs font-medium"
                                          })
                                    }),
                                className: "flex px-20-px overflow-x-auto"
                              })
                        ]
                      })
              ]
            });
}

var noMessage$1 = "";

var make = CampaignReport;

exports.ReportData = ReportData;
exports.emptyReports = emptyReports;
exports.initialState = initialState;
exports.reducer = reducer;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.emptyPageInfo = emptyPageInfo;
exports.noMessage = noMessage$1;
exports.make = make;
/* react Not a pure module */
